<template>
  <div class="login-shell">
    <section class="login-hero">
      <p class="eyebrow">dashcom member access</p>
      <h1>登录后继续你的购物流。</h1>
      <p>收藏、购物车、订单和消息中心会在登录后无缝接续。</p>
    </section>

    <div class="login-card card">
      <h2>用户登录</h2>

      <div v-if="message" :class="['alert', success ? 'alert-success' : 'alert-danger']">
        {{ message }}
      </div>

      <form @submit.prevent="login">
        <div class="form-group">
          <label for="username">用户名</label>
          <input
            id="username"
            v-model="form.username"
            type="text"
            required
            placeholder="请输入用户名"
          >
        </div>

        <div class="form-group">
          <label for="password">密码</label>
          <input
            id="password"
            v-model="form.password"
            type="password"
            required
            placeholder="请输入密码"
          >
        </div>

        <button type="submit" class="btn primary-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '登录中...' : '登录' }}
        </button>

        <div class="register-link">
          还没有账号？
          <router-link to="/register" class="primary-link">立即注册</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerLogin',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      message: '',
      success: false,
      isSubmitting: false
    }
  },
  created() {
    if (localStorage.getItem('customerToken')) {
      this.$router.push('/')
    }
    if (localStorage.getItem('sellerToken')) {
      this.message = '请先退出卖家账号后再登录用户端'
      this.success = false
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    }
  },
  methods: {
    async login() {
      this.isSubmitting = true
      this.message = ''

      try {
        const response = await this.$axios.post('/login', null, {
          params: {
            username: this.form.username,
            password: this.form.password
          }
        })

        const result = response.data
        if (result.success && result.token) {
          localStorage.setItem('customerToken', result.token)
          localStorage.setItem('customerUsername', this.form.username)

          this.success = true
          this.message = '登录成功，正在返回首页...'

          setTimeout(() => {
            this.$router.push('/')
          }, 1000)
        } else {
          this.success = false
          this.message = result.message || '用户名或密码错误'
        }
      } catch (err) {
        this.success = false
        this.message = '登录失败，请稍后重试'
        console.error(err)
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.login-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(380px, 460px);
  gap: 1.4rem;
  align-items: stretch;
  min-height: calc(100vh - 220px);
}

.login-hero,
.login-card {
  border-radius: 32px;
}

.login-hero {
  padding: 2rem;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.32)),
    radial-gradient(circle at 18% 20%, rgba(0, 113, 227, 0.16), transparent 30%),
    linear-gradient(180deg, rgba(250, 250, 252, 0.95), rgba(236, 239, 244, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-medium);
}

.eyebrow {
  margin: 0 0 0.8rem;
  color: var(--color-text-faint);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.login-hero h1 {
  margin: 0;
  max-width: 10ch;
  font-size: clamp(2.3rem, 4vw, 3.8rem);
  line-height: 1;
  letter-spacing: -0.05em;
  color: var(--color-text);
}

.login-hero p:last-child {
  max-width: 460px;
  margin: 1rem 0 0;
  color: var(--color-text-soft);
  line-height: 1.8;
}

.login-card {
  width: 100%;
  margin: 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.75);
  box-shadow: var(--shadow-soft);
}

.login-card h2 {
  margin: 0 0 1.5rem;
  color: var(--color-text);
  font-size: 1.8rem;
  letter-spacing: -0.03em;
}

.primary-btn {
  width: 100%;
  min-height: 52px;
}

.register-link {
  margin-top: 1rem;
  text-align: center;
  color: var(--color-text-soft);
}

.primary-link {
  color: var(--color-accent-strong);
  text-decoration: none;
  font-weight: 600;
}

.primary-link:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .login-shell {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .login-hero,
  .login-card {
    border-radius: 24px;
  }
}
</style>
